// #region Dependencias
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import useImprovedForm from 'hooks/useImprovedForm'
import { createPageRequest } from 'store/thunks/pagesThunks'
import { colors } from 'components/Library/theme'
import { DATOS_PAGINA } from 'utils/constants'
import Sidebar from 'components/Sidebar/Sidebar'
import Landing from 'components/Landing'
import { validacionesPagina } from 'utils/validations/pageValidations'
import { setDialogoAbierto } from 'store/slices/uiSlice'
// #endregion

// #region Estilos
const StyledCont = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const StyledDiv = styled.div`
  background-color: ${colors.light};
  padding: 2rem;
  width: 100%;
`
// #endregion

/**
 * Vista que renderiza el componente de landing page con la información de la
 * página seleccionada en modo de creación.
 * @class
 * @module Pages
 */
const PageCreator = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [formValues, setFormValues, handleInputChange, reset] = useImprovedForm(
    JSON.parse(JSON.stringify(DATOS_PAGINA))
  )

  /**
   * Función que crea una nueva página mediante el thunk {@link createPageRequest}
   */
  const handleSave = () => {
    const error = validacionesPagina(formValues)
    if (error) {
      return dispatch(
        setDialogoAbierto({
          abierto: true,
          tipo: 'error',
          titulo: 'Error de validación',
          mensaje: error
        })
      )
    }

    dispatch(createPageRequest(formValues, navigate))
  }

  return (
    <StyledCont>
      <StyledDiv>
        <Landing modoEdicion={true} valores={formValues} handleInputChange={handleInputChange} />
      </StyledDiv>
      <Sidebar
        modoEdicion={false}
        handleSave={handleSave}
        formValues={formValues}
        setFormValues={setFormValues}
        handleInputChange={handleInputChange}
        reset={reset}
      />
    </StyledCont>
  )
}

export default PageCreator
